import {inject, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {RuntimeService} from "../../core/services/runtime.service";

@Injectable({
    providedIn: 'root'
})
export class ThemeCustomizerService {

    private isDarkTheme: boolean;
    private isToggled = new BehaviorSubject<boolean>(false);
    readonly #runtimeService = inject(RuntimeService);

    constructor() {
        this.isDarkTheme = true;
    }

    get isToggled$() {
        return this.isToggled.asObservable();
    }

    toggleTheme() {
        this.isDarkTheme = !this.isDarkTheme;

        if (this.#runtimeService.isBrowser) {
            localStorage.setItem('isDarkTheme', JSON.stringify(this.isDarkTheme));
        }
    }

    isDark() {
        return this.isDarkTheme;
    }

}
